import { FeatureLineup } from '@mdlbeasts/nofomo.ui.web';
import { FormattedMessage } from 'react-intl';

import LoadingScreen from 'components/@common/LoadingScreen';

/**
 * Holds the section open while the lineup arrives, so a reader scrolling past
 * does not take it for an event without one.
 */
const LineupSelectionLoading = () => (
  <FeatureLineup.Shared.Section
    titleVariant="h6"
    title={<FormattedMessage id="event.header.tab.lineup" />}
  >
    <LoadingScreen sx={{ minHeight: 160 }} />
  </FeatureLineup.Shared.Section>
);

export default LineupSelectionLoading;
